// PDFs of the trade documents (src/lib/tradeDocs.js). The desktop app prints
// them with Chromium in the main process (main.js 'pdf-save' / 'pdf-render');
// in a plain browser the document opens in a new tab with the print dialog,
// where "Save as PDF" does the same job.
import { docHtml } from './tradeDocs';

const ipcRenderer = window.process?.type === 'renderer' ? window.require('electron').ipcRenderer : null;

// Email attachments need the PDF bytes, which only the desktop app can make.
export const canAttachPdf = !!ipcRenderer;

// Save As dialog, then opens the PDF. Resolves to { path }, { canceled } or
// { printed } (browser).
export async function savePdf(doc, { fileName, folder } = {}) {
  const html = docHtml(doc);
  if (!ipcRenderer) {
    printInBrowser(html);
    return { printed: true };
  }
  const res = await ipcRenderer.invoke('pdf-save', {
    html, pageSize: doc.pageSize, landscape: doc.landscape, fileName, folder,
  });
  if (res?.error) throw new Error(res.error);
  return res;
}

// The PDF as base64, for attaching to an email (desktop app only).
export async function pdfBase64(doc) {
  if (!ipcRenderer) return null;
  const res = await ipcRenderer.invoke('pdf-render', {
    html: docHtml(doc), pageSize: doc.pageSize, landscape: doc.landscape,
  });
  if (res?.error) throw new Error(res.error);
  return res.base64;
}

function printInBrowser(html) {
  const w = window.open('', '_blank');
  if (!w) throw new Error('The print tab was blocked. Allow pop-ups for Farm OS and try again.');
  w.document.open();
  w.document.write(html);
  w.document.close();
  const print = () => (w.document.fonts?.ready || Promise.resolve()).then(() => w.print());
  if (w.document.readyState === 'complete') print();
  else w.addEventListener('load', print);
}
